import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import RestaurantDashboard from '../pages/admin/RestaurantPanel';
import CustomerPanel from '../pages/customer/Panel';

import RestaurantLogin from '../pages/RestaurantLogin';
import CustomerLogin from '../pages/CustomerLogin';

import RestaurantOnboarding from '../pages/RestaurantOnboarding';
import DinelytLandingPage from '../pages/DinelytLandingPage';
import TermsAndConditionsPage from '../pages/TermsAndConditionsPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';

import ProtectedRoute from '../auth/ProtectedRoute';

const AppRoutes: React.FC = () => (
  <Router>
    <Routes>
      {/* Landing / Home */}
      <Route path="/" element={<DinelytLandingPage />} />
      <Route path="/home" element={<DinelytLandingPage />} />
      <Route path="/Terms_and_Conditions" element={<TermsAndConditionsPage />} />
      <Route path="/terms" element={<TermsAndConditionsPage />} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicyPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />

      {/* Owner Login + Onboarding */}
      <Route path="/restaurant/login" element={<RestaurantLogin />} />
      <Route path="/restaurant/onboarding" element={<RestaurantOnboarding />} />
      {/* ---------------- RESTAURANT USERS (Owner, Manager, Dining Associate, etc.) ---------------- */}
      <Route path="/restaurant/login" element={<RestaurantLogin />} />
      <Route
        element={
          <ProtectedRoute
            allowedRoles={["owner", "manager", "dining associate"]} // Add more as needed
            redirectTo="/restaurant/login"
          />
        }
      >
        <Route path="/restaurant/*" element={<RestaurantDashboard />} />
      </Route>

      {/* Customer Login */}
      <Route path="/customer-login" element={<CustomerLogin />} />
      <Route
        element={
          <ProtectedRoute allowedRoles={['customer']} redirectTo="/customer-login" />
        }
      >
        <Route path="/customer/:restaurantGuid/:tableId" element={<CustomerPanel />} />
      </Route>

      {/* Default */}
      <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  </Router>
);

export default AppRoutes;
